<!-- Floating toggle button -->
<button
    class="chat-toggle-btn"
    (click)="chatService.toggle()"
    [attr.aria-label]="chatService.isOpen() ? 'Close chat' : 'Open chat'"
>
    @if (chatService.isOpen()) {
        <!-- Close icon -->
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
    } @else {
        <!-- Chat bubble icon -->
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
    }
</button>

<!-- Chat panel -->
@if (chatService.isOpen()) {
    <div class="chat-panel">
        <!-- Header -->
        <div class="chat-header">
            <div class="chat-header-info">
                <div class="chat-avatar">H</div>
                <div>
                    <p class="chat-title">Hashbooks Assistant</p>
                    <p class="chat-subtitle">Ask me anything about crypto tax</p>
                </div>
            </div>
            <button class="chat-clear-btn" (click)="chatService.clearSession()" title="Clear conversation">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="1 4 1 10 7 10"></polyline>
                    <path d="M3.51 15a9 9 0 1 0 .49-3.51"></path>
                </svg>
            </button>
        </div>

        <!-- Messages -->
        <div class="chat-messages" #messageContainer>
            @if (chatService.messages().length === 0) {
                <div class="chat-empty">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="opacity:0.4; margin-bottom: 8px;">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    </svg>
                    <p>Hi! How can I help you with crypto taxes today?</p>
                </div>
            }

            @for (msg of chatService.messages(); track $index) {
                <div class="chat-message" [class.user]="msg.role === 'user'" [class.assistant]="msg.role === 'assistant'">
                    <div class="message-bubble">
                        {{ msg.content }}
                        @if (msg.isStreaming) {
                            <span class="typing-cursor">|</span>
                        }
                    </div>
                </div>
            }
        </div>

        <!-- Footer -->
        <div class="chat-footer">
            <div class="chat-input-row">
                <textarea
                    class="chat-input"
                    [(ngModel)]="inputText"
                    (keydown)="onKeydown($event)"
                    placeholder="Ask a question..."
                    rows="1"
                    [disabled]="chatService.isLoading()"
                ></textarea>
                <button
                    class="chat-send-btn"
                    (click)="onSend()"
                    [disabled]="chatService.isLoading() || !inputText().trim()"
                >
                    @if (chatService.isLoading()) {
                        <span class="loading-dot"></span>
                    } @else {
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                        </svg>
                    }
                </button>
            </div>
            <p class="chat-disclaimer">
                For account issues, contact
                <a href="mailto:support@hashbooks.tax">support&#64;hashbooks.tax</a>
            </p>
        </div>
    </div>
}
